export default "__VITE_ASSET__Byt6WbFo__"